export default {
  modelName: "locale",
  label: "語言列表",
  fields: {
    code: {
      type: "text",
      label: "代碼",
      rules: "required",
      autofocus: true,
      maxlength:10
    },
    name: {
      type: "text",
      label: "名稱",
      rules: "required",
      maxlength:10
    },
    backup_locale: {
      type: 'belongsTo',
      label: '備用語言',
      textKey: "name",
      modelName: "locale",
      excludeSelf: true
    },
    sequence: {
      type: "text",
      label: "排序",
      maxlength:10
    },
    updated_at: {
      type: "datetime",
      label: "最後更新時間",
      readonly: true,
    },
    updated_admin: {
      type: "belongsTo",
      label: "最後更新人",
      readonly: true,
      textKey: "name",
      modeldataName: "admin",
    },
    is_active: {
      type: 'switch',
      label: '顯示設定',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
}